import { ApiService } from "../../services/api.service";
import { AuthenticationService } from "../../services/authentication.service";
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from "@ngx-translate/core";
import { CALENDAR_LOCALE } from "../../services/constant";
import { HttpParams } from "@angular/common/http";
import * as _ from 'lodash';
import * as moment from 'moment';
var ImportDataComponent = (function () {
    function ImportDataComponent(apiService, authService, modelService, translate, modalService) {
        this.apiService = apiService;
        this.authService = authService;
        this.modelService = modelService;
        this.translate = translate;
        this.modalService = modalService;
        this.itemsPerPage = 40;
        this.startDate = null;
        this.endDate = null;
        this.totalItems = 0;
        this.selectedValues = [];
        this.currentPage = 1;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.tableCol = [];
        this.loading = false;
        this.disable = false;
        this.loading_main = false;
        this.checkdate = null;
    }
    ImportDataComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
        this.loadTexts();
    };
    ImportDataComponent.prototype.loadTexts = function () {
        var _this = this;
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.statusData = [
            { label: this.translate.instant('COMMON.ALL'), value: null },
            { label: this.translate.instant('TEXT.SUCCESS'), value: 'success' },
            { label: this.translate.instant('TEXT.FAILED'), value: 'failed' }
        ];
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            _this.tableCol = _.uniqBy(_this.tableCol, 'field');
        });
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
    };
    ImportDataComponent.prototype.resolveError = function ($event, popup, data) {
        this.modalData = data;
        this.disable = false;
        this.modal = this.modalService.open(popup, { backdrop: 'static', keyboard: false });
        // this.id_error = rowData.id;
    };
    ImportDataComponent.prototype.revertBack = function () {
        this.modal.close();
    };
    Object.defineProperty(ImportDataComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImportDataComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    ImportDataComponent.prototype.pageChanged = function () {
        // const params = new HttpParams().set('page', _.toString(this.currentPage));
        this.loadData();
    };
    ImportDataComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    ImportDataComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    ImportDataComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    ImportDataComponent.prototype.sentdate = function () {
        this.checkdate = 1;
    };
    ImportDataComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
    };
    ImportDataComponent.prototype.clearSearch = function () {
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.selectedStatus = null;
        this.startDate = null;
        this.endDate = new Date();
        this.startDate = new Date();
        this.sortBy = null;
        this.sortMode = null;
        this.totalItems = null;
        this.disable = false;
        this.modal = null;
        this.checkdate = null;
        this.loadTexts();
        this.loadData();
    };
    ImportDataComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.loadData();
    };
    ImportDataComponent.prototype.loadData = function (param) {
        var _this = this;
        this.tableData = [];
        this.totalItems = 0;
        this.loading = true;
        var startDates = moment(this.startDate).format('YYYY-MM-DD');
        var endDates = moment(this.endDate).format('YYYY-MM-DD');
        var params = new HttpParams();
        if (this.startDate) {
            params = params.append('header_issue_date_start', startDates);
            params = params.append('header_issue_date_end', endDates);
        }
        params = params.append('page', this.currentPage.toString());
        params = params.append('items_per_page', this.itemsPerPage.toString());
        if (this.selectedStatus) {
            params = params.append('status', this.selectedStatus);
        }
        this.apiService.getErrors(params).subscribe(function (data) {
            _.forEach(data.results, function (obj) {
                _this.tableData.push({
                    'created_at': obj.created_at,
                    'csv_name': obj.json.csv_name,
                    'status': obj.status,
                    'invoice_number': obj.invoice_number,
                    'detail': obj.detail
                });
                _this.totalItems = data.count;
            });
            _this.loading = false;
        });
    };
    return ImportDataComponent;
}());
export { ImportDataComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data.component.ts.pre-build-optimizer.js